import React, { InputHTMLAttributes } from "react"
import classnames from "classnames"
import { useFormContext } from "react-hook-form"
import { VALID_EMAIL } from "@usher/pe-client-front-end-lib"

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  refProps?: object
  required?: boolean
  theme?: string
  label?: string
  placeholder?: string
  emptyLabel?: boolean
  withSelect?: boolean
  isPinField?: boolean
}

export const CtrlInput = ({
  type = "text",
  name,
  theme = "Dark",
  label = "",
  placeholder = "",
  emptyLabel = false,
  withSelect = false,
  refProps = {},
  required = false,
  children,
  isPinField = false,
  ...rest
}: InputProps) => {
  const { register, errors } = useFormContext()

  if (required) refProps = { ...refProps, required: "This field is required." }
  if (type === "email") refProps = { ...refProps, ...VALID_EMAIL }

  // if (errors[name]) className += ' is-invalid'
  return (
    <div className={classnames("Form-InputBox", "Order-Card-PIN-Input", `Form-InputBox--${theme}`)}>
      {label && placeholder.length < 2 && <span className="Form-Input__Label">{label}</span>}
      {emptyLabel && <span className="Form-Input__Label">&nbsp;</span>}
      <input
        className={classnames("Form-Input", {
          [`Form-Input--${theme}`]: theme,
          [`Form-Input--WithSelect`]: withSelect,
        })}
        placeholder={placeholder}
        type={type}
        name={name}
        ref={register(refProps)}
        onKeyDown={(e) => {
          if (!isPinField) return
          const isBackspace = e.code === "Backspace" || e.code === "Tab"
          const isNumbers = /\d/.test(e.code)
          const isCtrlKey = e.ctrlKey || e.shiftKey
          if (isCtrlKey) return
          if (isBackspace) return
          if (e.currentTarget.value.length === 4) e.preventDefault()
          if (isNumbers) return
          e.preventDefault()
        }}
        onPaste={(e) => {
          if (!isPinField) return
          const value = e.clipboardData.getData("text")
          if (value.length > 4) {
            e.preventDefault()
            e.currentTarget.value = value.toString().substring(0, 4)
          }
        }}
        {...rest}
      />
      {children}
      {errors[name] && <div className="invalid-feedback">{errors[name].message}</div>}
    </div>
  )
}
